import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/components/layout.jsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SEO = makeShortcode("SEO");
const Menu = makeShortcode("Menu");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <SEO title="Octopath Traveler Primrose Lone Traveler Speedrun" mdxType="SEO" />
    <h3 {...{
      "id": "primrose-chapter-1"
    }}>{`Primrose Chapter 1`}</h3>
    <p>{`Buy `}<strong parentName="p">{`Arcane Knife`}</strong>{`, Allure `}<strong parentName="p">{`Elderly Woman`}</strong>{`. Pick `}<strong parentName="p">{`Shadow Stone`}</strong>{`.`}</p>
    <p>{`You can choose to kill whatever battles you want between here & `}<strong parentName="p">{`Scholar Shrine`}</strong>{`. You want 94JP before going to Scholar Shrine minimum.`}</p>
    <h4 {...{
      "id": "helgenish"
    }}>{`Helgenish`}</h4>
    <p>{`T1: Shadow Soulstone`}<br parentName="p"></br>{`
`}{`T2: Summon`}<br parentName="p"></br>{`
`}{`T3+: Dagger (Break)`}<br parentName="p"></br>{`
`}{`T4+: BPx4 Moonlight Waltz`}<br parentName="p"></br>{`
`}{`T5+: BPx3 Moonlight Waltz`}</p>
    <p>{`You can choose to pick `}<strong parentName="p">{`Old Coin`}</strong>{` and/or do Kit quest. Each of these give an extra restore reputation in `}<strong parentName="p">{`Cobbleston`}</strong>{`.`}</p>
    <p>{`Go to `}<strong parentName="p">{`Cobbleston`}</strong>{`.`}</p>
    <h3 {...{
      "id": "cobbleston"
    }}>{`Cobbleston`}</h3>
    <p>{`Sell Gold Items, optionally buy Healing Grapes. You want to have a multiple of $2000 left.`}</p>
    <p>{`Allure girl by Tavern (10%). Restore reputation costs $2000.`}<br parentName="p"></br>{`
`}{`Head to `}<strong parentName="p">{`Scholar Shrine`}</strong>{`.`}</p>
    <p>{`If you see a Cait, kill it with Summon and skip Whistlewood.`}<br parentName="p"></br>{`
`}{`You can use Summon to kill smaller battles, but you need 2-3 for Whistlewood & Scholar Shrine. I also like to save charges to go for YOLO Everhold area battle levelups.`}</p>
    <p>{`Go to Whistlewood, kill a battle (or 2) with Summon. You want to have 94JP before going to `}<strong parentName="p">{`Scholar Shrine`}</strong>{`.`}</p>
    <p>{`Kill Scholar Shrine battle with Summon, get Scholar.`}</p>
    <Menu mdxType="Menu">
      <p>{`Learn 2 Scholar skills, preferably Fire Storm for Stonegard battle, and Evasive Maneuvers.`}</p>
    </Menu>
    <p>{`Tag `}<strong parentName="p">{`Noblecourt`}</strong>{` and leave, pick `}<strong parentName="p">{`Light M`}</strong>{`, head to `}<strong parentName="p">{`Forest of Purgation`}</strong>{`.`}</p>
    <h3 {...{
      "id": "forest-of-purgation"
    }}>{`Forest of Purgation`}</h3>
    <p>{`Pick `}<strong parentName="p">{`Light L`}</strong>{` and `}<strong parentName="p">{`$20000`}</strong>{`.`}<br parentName="p"></br>{`
`}{`TP `}<strong parentName="p">{`Cobbleston`}</strong>{` and head to `}<strong parentName="p">{`Stonegard`}</strong>{`.`}</p>
    <blockquote>
      <p parentName="blockquote">{`For Stonegard battle, best chance of clearing is Firestorm, Light M, Firestorm, Summon`}<br parentName="p"></br>{`
`}{`If you don't have a Cait screen resetting these is a good idea.`}</p>
    </blockquote>
    <p>{`Tag `}<strong parentName="p">{`Stonegard`}</strong>{`, go to `}<strong parentName="p">{`Moonstruck Coast`}</strong>{`.`}</p>
    <p>{`Save at the save point, then run to `}<strong parentName="p">{`Merchant Shrine`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Kill the battle here with Light L`}</p>
    <blockquote>
      <p parentName="blockquote">{`If you ever miss a kill on a battle either because you skipped it or you died, you can either force it again or just take an extra Northreach battle later.`}</p>
    </blockquote>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs"
      }}>{`Jobs`}</h5>
      <p><strong parentName="p">{`Merchant`}</strong>{`, Hired Help`}</p>
      <p>{`Don't learn Sidestep yet unless you are really confident that you'll still get 430JP before Rufus.`}</p>
    </Menu>
    <p>{`Tag `}<strong parentName="p">{`Goldshore`}</strong>{`, head to `}<strong parentName="p">{`West Grandport Coast`}</strong>{`.`}</p>
    <blockquote>
      <p parentName="blockquote">{`The Wind L here is optional.`}</p>
    </blockquote>
    <p>{`Pick `}<strong parentName="p">{`Wind L`}</strong>{`, reset screen, pick `}<strong parentName="p">{`$20000`}</strong>{`, S&Q at the savepoint.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`Thunder L`}</strong>{`, tag `}<strong parentName="p">{`Grandport`}</strong>{`, and go to `}<strong parentName="p">{`Loch of the Lost King`}</strong>{`.`}</p>
    <h3 {...{
      "id": "loch-of-the-lost-king"
    }}>{`Loch of the Lost King`}</h3>
    <p>{`Pick `}<strong parentName="p">{`Wind L`}</strong>{` and `}<strong parentName="p">{`$30000`}</strong>{`. TP `}<strong parentName="p">{`Grandport`}</strong>{`.`}</p>
    <h3 {...{
      "id": "grandport"
    }}>{`Grandport`}</h3>
    <p>{`Buy `}<strong parentName="p">{`Knight Shield`}</strong>{` from Weapon/Armor shop.`}<br parentName="p"></br>{`
`}{`On next screen pick `}<strong parentName="p">{`Silver-filled Pouch.`}</strong><br parentName="p"></br>{`
`}{`On the next screen, get `}<strong parentName="p">{`$25000 + Artwork`}</strong>{`, TP to `}<strong parentName="p">{`Goldshore`}</strong>{` and head to `}<strong parentName="p">{`Captain's Bane`}</strong>{`.`}</p>
    <h3 {...{
      "id": "captains-bane"
    }}>{`Captain's Bane`}</h3>
    <p>{`Pick `}<strong parentName="p">{`Articulate Stone`}</strong>{`, TP `}<strong parentName="p">{`Stonegard`}</strong>{` and head to `}<strong parentName="p">{`West Everhold Pass`}</strong>{`.`}</p>
    <h3 {...{
      "id": "west-everhold-pass"
    }}>{`West Everhold Pass`}</h3>
    <p>{`Pick `}<strong parentName="p">{`Light L`}</strong>{` and `}<strong parentName="p">{`Silver-filled Pouch`}</strong>{`. Save at the save point.`}</p>
    <p>{`Whether or not you reload here is up to you. I like to just run to wherever I'm going and try to get a Flurry on the battle. If you get a Flurry, kill with an L Stone and skip a later battle. If you get the Grandport Coast Wind L, you don't need to skip a battle later. Make sure you have 1 Wind L for Wellspring battle later.`}</p>
    <p>{`Tag `}<strong parentName="p">{`Everhold`}</strong>{`, head to `}<strong parentName="p">{`Everhold Tunnels`}</strong>{`. Use same logic for save as before.`}</p>
    <h3 {...{
      "id": "everhold-tunnels"
    }}>{`Everhold Tunnels`}</h3>
    <p>{`Pick `}<strong parentName="p">{`Pom L`}</strong>{`. Reset steps & pick `}<strong parentName="p">{`$35000`}</strong>{`. Buffer glitch and pick `}<strong parentName="p">{`Bright Stone`}</strong>{`. Pick `}<strong parentName="p">{`Death Cleaver`}</strong>{`, and TP `}<strong parentName="p">{`Everhold`}</strong>{`.`}</p>
    <p>{`Head to `}<strong parentName="p">{`Shrine of the Runeblade`}</strong>{`, same rules as before. Pick `}<strong parentName="p">{`$50000`}</strong>{`.`}</p>
    <p>{`TP `}<strong parentName="p">{`Stonegard`}</strong>{`.`}</p>
    <h3 {...{
      "id": "stonegard"
    }}>{`Stonegard`}</h3>
    <p>{`Go to right screen. You can buy `}<strong parentName="p">{`11 Grape Ms`}</strong>{` here or any other shop that has them later on.`}<br parentName="p"></br>{`
`}{`Allure `}<strong parentName="p">{`Patrician Youth (35%)`}</strong>{` standing to the left of the church. Go to top screen and talk to guy by fountain with quest to get `}<strong parentName="p">{`Royal Crest`}</strong>{`.`}</p>
    <p>{`If you haven't done Everhold stuff yet, you can Allure the Hunter to the right to have someone with Flurry.`}</p>
    <p>{`TP `}<strong parentName="p">{`Sunshade`}</strong>{` and get `}<strong parentName="p">{`Apothecary Shrine`}</strong>{`.`}</p>
    <p>{`TP `}<strong parentName="p">{`Stonegard`}</strong>{`, head towards `}<strong parentName="p">{`Marsalim Catacombs`}</strong>{` through North Stonegard Pass path.`}</p>
    <p>{`In `}<strong parentName="p">{`Eastern Wellspring`}</strong>{`, pick the `}<strong parentName="p">{`Thunder L`}</strong>{` in the bottom left corner.`}<br parentName="p"></br>{`
`}{`Kill the battle here with `}<strong parentName="p">{`Wind L`}</strong>{`. Head down to `}<strong parentName="p">{`Eastern Marsalim Sands`}</strong>{`.`}</p>
    <p>{`Pick `}<strong parentName="p">{`Thunder L`}</strong>{` on the way to Catacombs and enter Catacombs.`}</p>
    <h3 {...{
      "id": "marsalim-catacombs"
    }}>{`Marsalim Catacombs`}</h3>
    <p>{`Buffer glitch to get `}<strong parentName="p">{`Master Spear`}</strong>{`. Pick `}<strong parentName="p">{`Revitalizing Jam`}</strong>{`, reset steps, and run out of Catacombs.`}<br parentName="p"></br>{`
`}{`Go to `}<strong parentName="p">{`Marsalim`}</strong></p>
    <h3 {...{
      "id": "marsalim"
    }}>{`Marsalim`}</h3>
    <p>{`Go to Palace, pick `}<strong parentName="p">{`Enchanted Circlet, $25,000, High House Armor`}</strong>{` in the three red chests in the room to the far right.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment"
      }}>{`Equipment`}</h5>
      <p>{`Optimize, Royal Crest, Bright Stone`}</p>
    </Menu>
    <p>{`TP `}<strong parentName="p">{`Noblecourt`}</strong>{` and run to `}<strong parentName="p">{`Stillsnow`}</strong>{`.`}</p>
    <p>{`In `}<strong parentName="p">{`Western Stillsnow Sands`}</strong>{`, don't reset steps and run to Stillsnow. Kill the battle here with Thunder L.`}<br parentName="p"></br>{`
`}{`If you took an extra battle earlier you can reset steps here to skip this one.`}</p>
    <h3 {...{
      "id": "stillsnow"
    }}>{`Stillsnow`}</h3>
    <p>{`Start Primrose Ch.2. After Alluring the Tavernkeeper and talking to Oren, run out towards `}<strong parentName="p">{`Northreach`}</strong>{`.`}</p>
    <h3 {...{
      "id": "northreach"
    }}>{`Northreach`}</h3>
    <p>{`Go to `}<strong parentName="p">{`Maw of the Ice Dragon`}</strong>{`. You can remove `}<strong parentName="p">{`Evasive Maneuvers`}</strong>{` to get a Lizard fight before Maw.`}</p>
    <p>{`In Maw pick `}<strong parentName="p">{`$30000`}</strong>{` and run out. Run to Northreach.`}<br parentName="p"></br>{`
`}{`Kill the battle with Bandits x2 / L Stone. You want to have 2 Stones after this, one of them being a Thunder L or Light L.`}<br parentName="p"></br>{`
`}{`Enter `}<strong parentName="p">{`Northreach`}</strong>{`.`}</p>
    <blockquote>
      <p parentName="blockquote">{`If you have < 430JP, after tagging Northreach take off Evasive Maneuvers, run back out and kill another battle. TP back to Northreach and repeat until you have at least 430JP. Put Evasive Maneuvers back on after.`}</p>
    </blockquote>
    <p>{`Buffer glitch into `}<strong parentName="p">{`Lorn Cathedral`}</strong>{`.`}</p>
    <h3 {...{
      "id": "lorn-cathedral"
    }}>{`Lorn Cathedral`}</h3>
    <blockquote>
      <p parentName="blockquote">{`There's a `}<strong parentName="p">{`Ice L`}</strong>{` in the bottom right corner of the first screen if you really need an L Stone.`}</p>
    </blockquote>
    <p>{`Go to second screen. Pick `}<strong parentName="p">{`Pom L`}</strong>{` and reset screen or S&Q. S&Q is prefered since the walk to `}<strong parentName="p">{`Void Amulet`}</strong>{` isn't safe. Go down path until steps go up. Follow those + the hidden path to the end and pick `}<strong parentName="p">{`Void Amulet`}</strong>{`.`}</p>
    <p>{`TP `}<strong parentName="p">{`Noblecourt`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Go to second screen and Allure `}<strong parentName="p">{`Luckless Sellsword (24%)`}</strong></p>
    <p>{`TP `}<strong parentName="p">{`Stillsnow`}</strong>{` and continue Chapter 2.`}</p>
    <h4 {...{
      "id": "rufus-30358hp"
    }}>{`Rufus 30358HP`}</h4>
    <ol>
      <li parentName="ol">{`Summon`}</li>
      <li parentName="ol">{`HHB x3`}</li>
      <li parentName="ol">{`L Stone`}</li>
    </ol>
    <p>{`If you have Sidestep, you can Sidestep x2 if you're before Rufus T4 to avoid Pummel. Pummel can unconscious for up to 6 Turns I think.`}</p>
    <p>{`T4 & on attack with Spear & wait for Full Enfeeblement. Once Full Enfeeblement break and kill with HHVx4`}<br parentName="p"></br>{`
`}{`If Luckless Sellsword got a lot of hits & you break early just HHVx4 finish with Luckless Sellsword damage if needed.`}</p>
    <p>{`TP `}<strong parentName="p">{`Noblecourt`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <p>{`Teach `}<strong parentName="p">{`Hale & Hearty`}</strong>{`, switch back to `}<strong parentName="p">{`Merchant`}</strong>{`.`}<br parentName="p"></br>{`
`}{`After equipping H&H heal with a grape.`}</p>
    </Menu>
    <h3 {...{
      "id": "obsidian-manse"
    }}>{`Obsidian Manse`}</h3>
    <p>{`Pick `}<strong parentName="p">{`$5000`}</strong>{`. S&Q on screen transition. Pick `}<strong parentName="p">{`Silver-filled Pouch`}</strong>{`. I recommend saving.`}</p>
    <h4 {...{
      "id": "albus-52599hp"
    }}>{`Albus 52599HP`}</h4>
    <ol>
      <li parentName="ol">{`HHM`}</li>
      <li parentName="ol">{`HHM x3`}</li>
      <li parentName="ol">{`Summon / Rev Jam if Albus first T4`}</li>
      <li parentName="ol">{`Summon / Rev Jam`}</li>
    </ol>
    <p>{`After this, focus on staying healthy and keeping BP up. Knock off shields when you have a chance.`}<br parentName="p"></br>{`
`}{`As soon as Luckless Sellsword does Full Enfeeblement, break with HHVx4 and do HHVx3. Then last turn do HHVx1 if Enfeeblement is up, else Defend > HHVx2.`}<br parentName="p"></br>{`
`}{`You can do this fight with 2 Vets if you have some extra damage from Luckless Sellsword or knock off more shields before breaking, but you have money for an extra HHV anyway so might as well use it.`}</p>
    <h3 {...{
      "id": "noblecourt"
    }}>{`Noblecourt`}</h3>
    <p>{`Dismiss Luckless Sellsword, and go Allure him again. You want to refresh his charges.`}<br parentName="p"></br>{`
`}{`I'd say you want 4 minimum, if you want to consider YOLOing and skipping this.`}</p>
    <p>{`TP `}<strong parentName="p">{`Everhold`}</strong>{`.`}</p>
    <h3 {...{
      "id": "everhold"
    }}>{`Everhold`}</h3>
    <p>{`Pick `}<strong parentName="p">{`Rare Stone`}</strong>{`.`}</p>
    <p>{`Enter Ampitheatre, pick `}<strong parentName="p">{`Fire L`}</strong>{` and `}<strong parentName="p">{`$30000`}</strong>{`. TP `}<strong parentName="p">{`Everhold`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs--skills"
      }}>{`Jobs & Skills`}</h5>
      <p>{`Learn `}<strong parentName="p">{`Sidestep`}</strong>{`, equip `}<strong parentName="p">{`Endless Items`}</strong>{`.`}</p>
      <h5 {...{
        "id": "equipment-1"
      }}>{`Equipment`}</h5>
      <p>{`Attach `}<strong parentName="p">{`Void Amulet`}</strong>{` & `}<strong parentName="p">{`Articulate Stone`}</strong>{`.`}</p>
    </Menu>
    <p>{`Go to shop, sell all gold items, Master Spear, Death Cleaver, and unneeded accessories if you needed.`}<br parentName="p"></br>{`
`}{`You should have at least $218500.`}</p>
    <p>{`Go back to Ampitheatre. Pick `}<strong parentName="p">{`$20000`}</strong>{`, can choose to S&Q at screen transition.`}</p>
    <p>{`Pick `}<strong parentName="p">{`Light L`}</strong>{`. Pick `}<strong parentName="p">{`Revitalizing Jam`}</strong>{`. Pick `}<strong parentName="p">{`Pom L`}</strong>{`. I recommend saving.`}</p>
    <blockquote>
      <p parentName="blockquote">{`You want the 2 L Stones from here, 1 other L Stone, 1 Rev Jam, and at least 2 Pom Ls going into this fight.`}<br parentName="p"></br>{`
`}{`You have 3 Vets available for Simeon 1 and 5 for Simeon 2.`}</p>
    </blockquote>
    <h3 {...{
      "id": "simeon-1-64300hp-father-marionette-24483hp-dancer-marionette-19785hp"
    }}>{`Simeon 1 64300HP Father Marionette 24483HP Dancer Marionette 19785HP`}</h3>
    <blockquote>
      <p parentName="blockquote">{`You're not guaranteed to survive T1/2, but should most of the time at LVL19/20.`}</p>
    </blockquote>
    <ol>
      <li parentName="ol">{`Defend / Sidestep if before Puppets T2.`}</li>
      <li parentName="ol">{`Sidestep x3`}</li>
      <li parentName="ol">{`Revitalizing Jam`}</li>
      <li parentName="ol">{`Sidestep x4`}</li>
      <li parentName="ol">{`Light L`}</li>
      <li parentName="ol">{`Sidestep x4`}</li>
      <li parentName="ol">{`Pom L`}</li>
      <li parentName="ol">{`Bandits x3`}</li>
      <li parentName="ol">{`Fire L `}<strong parentName="li">{`(Delay this if there is a Def buff on Male Puppet. Ideally there isn't one on anyone but that's the only one that breaks the setup. Stall turns with Sidesteps. You also want to have at least 1 Sidestep up before breaking, preferably 2. If you're full HP you should be fine most of the time though.)`}</strong></li>
      <li parentName="ol">{`HHV x4`}</li>
      <li parentName="ol">{`L Stone`}</li>
    </ol>
    <p>{`From here on out, just Summon, break +Full Enfeeblement and use Vets. You can mitigate Simeons attacks with Sidesteps or just healing. You have 2 Vets available for this. If possible preserve charges for Simeon 2.`}<br parentName="p"></br>{`
`}{`You only need Full Enfeeblement for 1 set of Vets as long as Luckless Sellsword gets some good hits in.`}</p>
    <h3 {...{
      "id": "simeon-2"
    }}>{`Simeon 2`}</h3>
    <blockquote>
      <p parentName="blockquote">{`Simeon does 1 Physical attack every turn in his starting pattern. Use that to count how many sidesteps you need.`}</p>
    </blockquote>
    <ol>
      <li parentName="ol">{`Sidestep`}</li>
      <li parentName="ol">{`Sidestep x3`}</li>
      <li parentName="ol">{`Pom L`}</li>
      <li parentName="ol">{`Sidestep x4`}</li>
      <li parentName="ol">{`Attack`}</li>
      <li parentName="ol">{`Sidestep x4`}</li>
    </ol>
    <p>{`From here, get his shields low with attacks and get BP back up. Make sure you maintain sidesteps as well.`}<br parentName="p"></br>{`
`}{`When he's down to a few shields, Summon. And when you get Full Enfeeblement, Break and HHVx4. Keep Sidesteps up while waiting for Enfeeblement, you can boost up to 3x if you have max BP`}</p>
    <p>{`Phase 2 is the trickiest. You want to knock off some shields here with HHV without putting him below half HP. He switches patterns at below half, and will eat through Sidesteps like crazy. You want to HHV early, then get shields down to 1 with HHM, then once you get Full Enfeeblement and are full BP break with HHVx4 and follow with HHVx3. You also want to have at least 1 Sidestep or enough HP to tank an attack going into next phase.`}</p>
    <p>{`After the second break you just Pom M and HHVx4. He should only get 1 attack in here max, due to him switching phases.`}</p>
    <p>{`GG!`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      